var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"vam"},[_vm._l(((_vm.texts)),function(item,index){return _c('span',{key:item.index,staticClass:"vam",style:(_vm._f("transRpxStyle")([(item.highlight ? _vm.highlightStyle : _vm.computedCommonStyle)]))},[_vm._v(_vm._s(item.value))])}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }